<template>
  <div class="line-top">
    <div class="table-wrapper">
      <div class="table-padrao">
        <table data-tablesaw-mode="swipe">
          <thead>
            <tr>
              <th v-if="customers.length > 1" class="column_cnpj">
                CNPJ
              </th>
              <th v-if="customers.length > 1" class="column_name">
                Razão Social
              </th>
              <th class="column_our_number">
                Nosso Número
              </th>
              <th class="column_document_number">
                Número do Documento
              </th>
              <th class="column_due_date">
                Vencimento
              </th>
              <th class="column_value">
                Valor
              </th>
              <th class="column_action">
                Ação
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in chunkTickets">
              <th v-if="customers.length > 1">
                {{ item.cnpj }}
              </th>
              <th v-if="customers.length > 1">
                {{ item.name }}
              </th>
              <th>
                {{ item.our_number }}
              </th>
              <th>
                {{ item.document_number }}
              </th>
              <th>
                {{ item.due_date }}
              </th>
              <th>
                {{ item.value }}
              </th>
              <th>
                <button
                  @click="downloadTickets(item.download_key)"
                  class="btn-download"
                >
                  <img
                    src="/public/site-representante/imagens/download-icon.png"
                    width="24"
                    height="24"
                  />
                  <span>DOWNLOAD</span>
                </button>
              </th>
            </tr>
          </tbody>
          <tfoot v-if="filterTickets.length === 0 || loadingSearch">
            <tr>
              <th colspan="9">
                <div slot="spinner">
                  <vue-element-loading
                    :active="loadingSearch"
                    spinner="bar-fade-scale"
                  />
                </div>
                <div class="no-results" slot="no-results">
                  <small v-if="filterTickets.length === 0"
                    >Nenhum resultado encontrado</small
                  >
                </div>
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
      <c-pagination
        v-if="filterTickets.length > chunkSize"
        :total-pages="Math.ceil(filterTickets.length / chunkSize)"
        :current-page="page"
        @page-selected="changePage"
      />
    </div>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <p><br />Solicitando boleto ao banco Itaú...</p>
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "../../../../../../../../../resources/assets/js/mixins/formatMixin";

export default {
  mixins: [formatMixin],
  props: {
    tickets: {
      type: Array,
      required: true,
    },
    accessToken: String,
    customers: [Array],
  },
  data() {
    return {
      page: 1,
      chunkSize: 20,
      loading: false,
      loadingSearch: false,
      filterTickets: [...this.tickets],
      chunkTickets: [],
    };
  },
  watch: {
    page: {
      handler() {
        this.mountChunkTickets();
      },
      deep: true,
    },
  },
  methods: {
    search(filtros) {
      this.loadingSearch = true;
      this.filterTickets = this.tickets.filter((ticket) => {
        let result = true;
        for (const key in filtros) {
          if (filtros[key] && ticket[key]) {
            result =
              result &&
              ticket[key].toLowerCase().includes(filtros[key].toLowerCase());
          }
        }
        return result;
      });
      if (this.page === 1) {
        this.mountChunkTickets();
      } else {
        this.page = 1;
      }
      this.loadingSearch = false;
    },
    mountChunkTickets() {
      this.chunkTickets = this.filterTickets.slice(
        // inicio do chunk atual
        (this.page - 1) * this.chunkSize,
        // fim do chunk atual
        (this.page - 1) * this.chunkSize + this.chunkSize
      );
    },
    changePage(page) {
      this.page = page;
    },
    downloadTickets(downloadKey) {
      this.loading = true;
      const URL = NEW_API_URL;

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      async function fetchData() {
        try {
          await this.axios
            .get(
              URL + "/api/my-orders/my-orders-customers/bank-slips/download",
              {
                params: { download_key: downloadKey },
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.accessToken}`,
                },

                responseType: "blob",
              }
            )
            .then(async (response) => {
              if (response && response.data) {
                const blob = response.data;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = url;
                link.setAttribute("download", "boleto-itau.pdf");

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                await sleep(3000);
              } else {
                this.$fire({
                  text: "Erro ao baixar o arquivo!",
                  type: "error",
                  confirmButtonText: "OK",
                  allowOutsideClick: true,
                });
              }
            })
            .catch((error) => {
              this.$fire({
                text: "Erro ao tentar acessar o arquivo!",
                type: "error",
                confirmButtonText: "OK",
                allowOutsideClick: true,
              });
            });
        } catch (error) {
          this.$fire({
            text: "Erro na requisição!",
            type: "error",
            confirmButtonText: "OK",
            allowOutsideClick: true,
          });
        } finally {
          this.loading = false;
        }
      }

      fetchData.call(this);
    },
  },
};
</script>
